import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
// import { IChat, IChatCreate } from '@common/models/Chat/IChat';
import { ApiService } from 'quangular';
import { IDocument } from '@common/models/Document/IDocument';
import { IChat } from '@common/models/Chat/IChat';
import { IChatDocument } from '@common/models/Chat/IChatDocument';
import { IAddDocumentToChat } from '@common/models/Chat/IAddDocumentToChat';
import { SummaryType } from '@common/enums/SummaryType';
import { IDocumentSummary } from '@common/models/Document/IDocumentSummary';
import { IDeltaTable } from '@common/models/Document/IDeltaTable';
import { IAddDoctoChatAPIResp } from '@common/models/Chat/IAddDoctoChatAPIResp';


@Injectable({
    providedIn: 'root',
})
export class DocumentService {
    defaultWFDOTables: IDeltaTable[] = [];
    private readonly defaultWFDOTablesObs = new Subject<IDeltaTable[]>();
    
    
    constructor(private http: HttpClient, private apiService: ApiService) {}

    getAllDocs(params): Observable<IDocument[]> {
        let url=`documents?pageSize=${params.pageSize}`
        if(params.markerId){
            url=`documents?pageSize=${params.pageSize}&markerId=${params.markerId}&loadMore=true`
        }
        if(params.search && params.search.trim()!=''){
            url=`documents?searchText=${params.search.trim()}`
        }
        return this.apiService.get<IDocument[]>(
           url
        );
    }

    uploadFile(params: FormData, forceUpload?: boolean): Observable<IDocument> {
        let url = `documents`;
        if (forceUpload) {
            url = `documents?forceUpload=${forceUpload}`;
        }
        return this.apiService.post(url, params);
    }

    uploadFolder(params: any, path?: any,forceUpload?: boolean): Observable<IDocument[]> {
      let url = `documents/upload-folder`;
      if (forceUpload) {
          url = `documents/upload-folder?forceUpload=${forceUpload}`;
      }
      const options = { headers: new HttpHeaders(), params: { path: path } };
      return this.apiService.post(url, params, options);
  }

    generateSummary(documentId: string, summaryType: SummaryType): Observable<IDocumentSummary>{
        return this.apiService.post(`documents/${documentId}/summary?type=${summaryType}`,{});
     }

    generateDocUpdates(documentId: string): Observable<IDocumentSummary>{
      return this.apiService.put(`documents/${documentId}/document-updates`,{});
    }

    updateChatDocuments(
        docs: IChatDocument[],
        chatId: string,
        tables?: IDeltaTable[],
    ): Observable<IAddDoctoChatAPIResp> {
        const payload: IAddDocumentToChat = {
            document: docs,
        };
        if(tables){
          payload.tables = tables
        }
        return this.apiService.post(`documents/chats/${chatId}`, payload);
    }

    getSummary(docId?: string): Observable<IDocumentSummary> {
        return this.apiService.get<IDocumentSummary>(
            `documents/${docId}/summary`,
        );
    }

    downloadFile(docId:string): Observable<Response> {
        return this.apiService.get<Response>(`documents/${docId}/download`);
    }

    deleteDoc(docId: string,documentName:string): Observable<Response> {
        return this.apiService.delete(`documents/${docId}?documentName=${documentName}`);
    }

    retriggerUploadFile(doc_Id:string): Observable<IDocument> {
        let url = `documents/${doc_Id}/retrigger`;
        return this.apiService.put(url,{});
    }

    getTablesFromExcel(doc_Id:string): Observable<any> {
        return this.apiService.get<string[]>(`documents/${doc_Id}/tables`)
    }

    getAllDeltaTables(params): Observable<IDeltaTable[]> {
      let url=`delta-tables?pageSize=${params.pageSize}`
      if(params.markerId){
          url=`delta-tables?pageSize=${params.pageSize}&markerId=${params.markerId}&loadMore=true`
      }
      if(params.search && params.search.trim()!=''){
          url=`delta-tables?searchText=${params.search.trim()}`
      }
      return this.apiService.get<IDeltaTable[]>(
         url
      );
    }

    getUniqueESGTableCategories() :Observable<string[]> {
      return this.apiService.get<string[]>('delta-tables/esg/categories')
    }

    getListOfESGTablesForCategory(category:string) :Observable<IDeltaTable[]> {
      return this.apiService.get<IDeltaTable[]>(`delta-tables/esg/tables-by-category?category=${category}`)
    }

    setDefaultWFDOTablesList(deltaTables: IDeltaTable[]) {
        this.defaultWFDOTables = deltaTables;
        this.defaultWFDOTablesObs.next(deltaTables);
    }

    getDefaultWFDOTablesListObs(): Observable<IDeltaTable[]> {
        return this.defaultWFDOTablesObs.asObservable();
    }
}
